import Component from './Component';
import ModalComponent from './ModalComponent';
import FormComponent from './FormComponent';
import VerificationCapComponent from './VerificationCapComponent';
import MapsComponent from "../utils/MapsComponent";
export default class POSSelectionComponent extends Component {
    get SELECTORS() {
        return {
            main: '.js-posselection',
            html: '.html',
            header: 'header',
            templateId: 'posselection--template',
            dataLogged: 'data-logged',
            dataCSRFToken: 'data-csrftoken',
            drivePanel: '.drive-panel',
            driveStore: '.drive-store',
            changeDrivePopup: '.popup.change-drive',
            dataPosName: 'data-posname',
            dataDescription: 'data-description',
            templateIdDrive: 'driveStore--template',
            driveCta: '.js-drive-panel',
            driveCancel: '.js-cancel-drive',
            changeDrive: '.js-change-drive',
            addContentPopup: '.js-drive-content-popup',
            searchDriveInput: 'searchDriveInput',
            resultsSearchDrive: '.js-drive-search-results',
            driveSelected: '.js-drive-selected',
            cityLatId: 'cityLat',
            cityLngId: 'cityLng',
            dataLat: 'data-lat',
            dataLng: 'data-lng',
            driveStoreNearest: '.drive-store__title-available',
            changeDriveDetails: '.change-drive__details',
            changeDriveName: '.change-drive__name',
            changeDriveNearest: '.change-drive__nearest',
            driveSearchForm: 'driveSearchForm',
            dataStore: 'data-store',
            noGeolocationPopup: 'noGeolocationPopup'
        }
    }

    get CLASSES() {
        return {
            close: 'close',
            backdropUp: 'backdrop__up',
        }
    }

    get DATA() {
        return {
            homeAssociated: 'data-home-associated',
        }
    }

    get LOCAL_STORAGE_ITEMS() {
        return {
            homeAssociated: 'homeAssociated',
        }
    }

    get PARAMS() {
        return {
            openminicart: 'openminicart',
            opendrivepanel: 'opendrivepanel',
            databack: 'databack',
            shop: 'shop'
        }
    }

    constructor() {
        super();
        this.initialize = false;
        this.ModalComponent = new ModalComponent();
        this.FormComponent = new FormComponent();
        this.VerificationCapComponent = new VerificationCapComponent();
        this.MapsComponent = new MapsComponent();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.SELECTORS.dataCSRFToken);
    }

    checkParamsDrivePanel() {
        const params = new URLSearchParams(window.location.search);
        if(params.get(this.PARAMS.opendrivepanel) === 'true') {
            window.history.replaceState('', '', this.removeParams(window.location.href.split('?')[0]+'?', this.PARAMS.opendrivepanel));
            this.openDrivePanel();
        }
        if (params.get(this.PARAMS.shop)) {
            window.history.replaceState('', '', this.removeParams(window.location.href.split('?')[0]+'?', this.PARAMS.shop));
        }
    }

    getDriveByCoords(obj) {  
        fetch(this.endpoints.POS_SELECTION_NEAREST.url, {
            method: 'post',
            body: JSON.stringify(obj),
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            // this.renderMustache(this.SELECTORS.templateId, document.querySelector(this.SELECTORS.main), data);
            // const store = {stores: this.formatStartTime([data])};
            // this.renderMustache(this.SELECTORS.templateIdDrive, document.querySelector(this.SELECTORS.driveSelected), store);
            localStorage.setItem("geoloc", true);
            location.reload();
            
        })
    }

    getNearestPos(latitude, longitude) {
        const urlEndpoint = this.endpoints.POS_NEAREST_LIST.url + '?latitude=' + latitude + '&longitude=' + longitude;
        let driveSelected = document.querySelector(this.SELECTORS.driveSelected + ' ' + this.SELECTORS.driveStore);

        fetch(urlEndpoint, {
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                data = data.filter(store => store.name != driveSelected.getAttribute('id'));
                const store = {stores: this.formatStartTime(data)};
                if (!window.location.href.includes('storefinder') && !this.initialize) {
                    this.initializeMap();
                }
                this.renderMustache(this.SELECTORS.templateIdDrive, document.querySelector(this.SELECTORS.resultsSearchDrive), store);
            }
        });
    }

    formatStartTime(stores) {
        const now = new Date();   
        stores.forEach( (store) => {
            if(store.firstAvailableTimeSlotPickup != null){
                const datePickup = new Date(store.firstAvailableTimeSlotPickup.startTime.substring(0,4), store.firstAvailableTimeSlotPickup.startTime.substring(4,6) - 1, store.firstAvailableTimeSlotPickup.startTime.substring(6,8));                
                store.firstAvailableTimeSlotPickup.startTimeDayName = this.datesAreOnSameDay(now,datePickup) ? 'oggi' : this.getDayName(datePickup);           
            }
            if(store.firstAvailableTimeSlotHD != null){
                const dateHome = new Date(store.firstAvailableTimeSlotHD.startTime.substring(0,4), store.firstAvailableTimeSlotHD.startTime.substring(4,6) - 1, store.firstAvailableTimeSlotHD.startTime.substring(6,8));                
                store.firstAvailableTimeSlotHD.startTimeDayName = this.datesAreOnSameDay(now,dateHome) ? 'oggi' : this.getDayName(dateHome);   
            }
            if(store.associatedCommerce != null) {
                if(store.associatedCommerce.firstAvailableTimeSlotPickup != null) {
                    const dateAcPickup = new Date(store.associatedCommerce.firstAvailableTimeSlotPickup.startTime.substring(0,4), store.associatedCommerce.firstAvailableTimeSlotPickup.startTime.substring(4,6) - 1, store.associatedCommerce.firstAvailableTimeSlotPickup.startTime.substring(6,8));           
                    store.associatedCommerce.firstAvailableTimeSlotPickup.startTimeDayName = this.datesAreOnSameDay(now,dateAcPickup) ? 'oggi' : this.getDayName(dateAcPickup);
                }
                if(store.associatedCommerce.firstAvailableTimeSlotHD != null) {
                    const dateAcHome = new Date(store.associatedCommerce.firstAvailableTimeSlotHD.startTime.substring(0,4), store.associatedCommerce.firstAvailableTimeSlotHD.startTime.substring(4,6) - 1, store.associatedCommerce.firstAvailableTimeSlotHD.startTime.substring(6,8));           
                    store.associatedCommerce.firstAvailableTimeSlotHD.startTimeDayName = this.datesAreOnSameDay(now,dateAcHome) ? 'oggi' : this.getDayName(dateAcHome);
                }
            }       
        })
        return stores;
    }

    datesAreOnSameDay(first, second) {
        return first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate();
    }
    getDayName(date) {
        const daysName = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
        return daysName[date.getDay()];
    }

    geolocation() {
        const ctx = this;
        let driveSelected = document.querySelector(this.SELECTORS.driveSelected + ' ' + this.SELECTORS.driveStore);
        
        if (!navigator.geolocation) {
            this.log('Geolocation is not supported by your browser');
        } else {
            navigator.geolocation.getCurrentPosition(function (position) {
                const latitude = position.coords.latitude,
                longitude = position.coords.longitude,
                accuracy = position.coords.accuracy;

                const geoPoint = {
                    'latitude': latitude,
                    'longitude': longitude
                };

                if(accuracy > 10000) {
                    ctx.ModalComponent.openModal(document.getElementById(ctx.SELECTORS.noGeolocationPopup));
                    ctx.getNearestPos(latitude, longitude);
                    localStorage.setItem("geoloc", true);
                }
                else {
                    ctx.getDriveByCoords(geoPoint);
                }
                // ctx.getNearestPos(latitude, longitude);

            }, function (error) {
                ctx.log('Error location…');
                ctx.getNearestPos(driveSelected.getAttribute(ctx.SELECTORS.dataLat), driveSelected.getAttribute(ctx.SELECTORS.dataLng));
            });
        }
    }

    openDrivePanel() {
        const drivePanel = document.querySelector(this.SELECTORS.drivePanel);
        this.ModalComponent.openModal(drivePanel);
        this.FormComponent.resetForm(this.SELECTORS.driveSearchForm);
        drivePanel.classList.remove(this.CLASSES.close);
    }

    searchDrive(form) {
        let latitude = document.getElementById(this.SELECTORS.cityLatId).value,
        longitude = document.getElementById(this.SELECTORS.cityLngId).value;
        
        if (latitude && longitude) this.getNearestPos(latitude, longitude);
    }

    popupCancel() {
        document.querySelector(this.SELECTORS.changeDrivePopup).classList.add(this.CLASSES.close);
        document.querySelector(this.SELECTORS.drivePanel).classList.remove(this.CLASSES.close);
        document.querySelector(this.SELECTORS.drivePanel).classList.add(this.CLASSES.backdropUp);
    }

    addContentPopup(element) {
        let changePopup = document.querySelector(this.SELECTORS.changeDrivePopup),
        driveStore = element.closest(this.SELECTORS.driveStore);

        changePopup.querySelector(this.SELECTORS.changeDrive).setAttribute(this.SELECTORS.dataPosName, driveStore.getAttribute('id'));
        changePopup.querySelector(this.SELECTORS.changeDriveDetails).setAttribute('href', '/storefinder/iper/' + driveStore.getAttribute('id'));
        changePopup.querySelector(this.SELECTORS.changeDriveName).innerHTML = driveStore.getAttribute(this.SELECTORS.dataDescription);
        changePopup.querySelector(this.SELECTORS.changeDriveNearest).innerHTML = driveStore.querySelector(this.SELECTORS.driveStoreNearest).textContent;
    }

    changeDrive(element, page = null) {
        let driveStore = null,
            driveId = null;
        
        if (!!element.getAttribute(this.DATA.homeAssociated)) {
            localStorage.setItem(this.LOCAL_STORAGE_ITEMS.homeAssociated, true);
        }

        if(!page) {
            if (element.hasAttribute(this.SELECTORS.dataPosName)) {
                let posName = element.getAttribute(this.SELECTORS.dataPosName);
                driveStore = document.getElementById(posName);
            }
            else {
                driveStore = element.closest(this.SELECTORS.driveStore);
            }
            driveId = driveStore.getAttribute('id');
        }
        else {
            driveId = element.getAttribute(this.SELECTORS.dataStore); 
        }
        
        fetch(this.endpoints.POS_SELECT.url, {
            method: 'post',
            body: JSON.stringify(driveId),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json', // This is set on request
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            if (data) {
                // const temp = document.querySelectorAll(this.SELECTORS.main);
                // for(const s of temp) {
                //     s.innerHTML = driveStore.getAttribute(this.SELECTORS.dataDescription);
                // }
                // this.ModalComponent.close();                            
                // document.querySelector(this.SELECTORS.driveSelected).innerHTML = '';
                // document.querySelector(this.SELECTORS.driveSelected).appendChild(driveStore);
                // this.getNearestPos(driveStore.getAttribute(this.SELECTORS.dataLat), driveStore.getAttribute(this.SELECTORS.dataLng));
                const params = new URLSearchParams(window.location.search);
                if(params.get(this.PARAMS.databack) === 'true') {
                    window.history.replaceState('', '', this.removeParams(window.location.href.split('?')[0]+'?', this.PARAMS.databack));
                }
                page === 'onlineOrders' ? location.href = '/?' + this.PARAMS.openminicart + '=true' : location.reload();
            }
        });
    }

    initAutocomplete() {
        const options = {
            componentRestrictions: { country: 'it' },
            types: ['(regions)']
        };
        
        const input = document.getElementById(this.SELECTORS.searchDriveInput);
        const autocomplete = new google.maps.places.Autocomplete(input, options);
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            let place = autocomplete.getPlace();
            document.getElementById(this.SELECTORS.cityLatId).value = place.geometry.location.lat();
            document.getElementById(this.SELECTORS.cityLngId).value = place.geometry.location.lng();
            this.searchDrive(document.getElementById(this.SELECTORS.driveSearchForm));
        });
    }

    initializeMap() {
        this.MapsComponent
            .loadLibraries()
            .then(() => {
                this.initAutocomplete();
                if (!!document.getElementById('verificationCapPopup')) {
                    this.VerificationCapComponent.initCapAutocomplete();
                }
            })
    }

    bindEvents() {     
        const driveCta = document.querySelectorAll(this.SELECTORS.driveCta),
        cancelDriveChange = document.querySelectorAll(this.SELECTORS.driveCancel),
        formId = document.getElementById(this.SELECTORS.driveSearchForm);

        for (const el of driveCta) {
            el.addEventListener('click', (e) => {
                //this.ModalComponent.closeModal();
                this.openDrivePanel();
            });
        }

        for (const el of cancelDriveChange) {
            el.addEventListener('click', (e) => {
                this.popupCancel();
            });
        }

        formId.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.searchDrive(formId);
        });

        this.events.on('click', this.SELECTORS.changeDrive, (e) => {
            this.changeDrive(e.target);
        });

        this.events.on('click', this.SELECTORS.addContentPopup, (e) => {
            this.addContentPopup(e.target);
        });
    }

    render() {
        this.log('render POS Selection');

        const driveSelected = document.querySelector(this.SELECTORS.driveSelected + ' ' + this.SELECTORS.driveStore),
        isLogged = this.getDataAttribute(this.SELECTORS.header, this.SELECTORS.dataLogged);

        if (isLogged === 'false' && localStorage.getItem("geoloc") !== 'true' && window.location.search.indexOf(this.PARAMS.shop) == -1) {
            this.geolocation();
        } else {
            this.getNearestPos(driveSelected.getAttribute(this.SELECTORS.dataLat), driveSelected.getAttribute(this.SELECTORS.dataLng));
        }

        this.checkParamsDrivePanel()

        this.bindEvents();
    }
}